import React, { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import IdleTimer from "react-idle-timer";
import { ConfirmDialogMUI } from "../confirm-dialog-mui";
import { logout } from "../../redux/actions";

const IDLE_TIMEOUT_MIN = parseInt(process.env.REACT_APP_IDLE_TIMEOUT_MIN, 10) || 14;
const IDLE_TIMEOUT_MS = IDLE_TIMEOUT_MIN * 60 * 1000;
const COUNTDOWN_SECONDS = 60;

const IdleTimerContainer = () => {
  const idleTimerRef = useRef(null);

  const dispatch = useDispatch();
  const my = useSelector((state) => state.my);

  const [openIdleModal, setOpenIdleModal] = useState(false);
  const sessionTimeoutRef = useRef(null);

  const [counter, setCounter] = useState(COUNTDOWN_SECONDS);
  const [startCountingDown, setStartCountingDown] = useState(false);

  useEffect(() => {
    if (startCountingDown) {
      const timer =
        counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [counter, startCountingDown]);

  const onIdle = () => {
    setOpenIdleModal(true);
    setStartCountingDown(true);
    sessionTimeoutRef.current = setTimeout(logOut, COUNTDOWN_SECONDS * 1000);
  };

  const stayActive = () => {
    setOpenIdleModal(false);
    setCounter(COUNTDOWN_SECONDS);
    setStartCountingDown(false);
    clearTimeout(sessionTimeoutRef.current);
  };

  const logOut = () => {
    setOpenIdleModal(false);
    clearTimeout(sessionTimeoutRef.current);
    const isUser = my.user.authorities.localeCompare("ROLE_USER") === 0;
    dispatch(logout({ isUser }));
  };

  return (
    <div>
      <ConfirmDialogMUI
        handleClose={() => setOpenIdleModal(false)}
        open={openIdleModal}
        text={`Automatyczne wylogowanie nastąpi za ${counter} ${
          counter > 4 || counter === 0
            ? "sekund"
            : counter < 5 && counter > 1
            ? "sekundy"
            : "sekundę"
        }`}
        yesAction={logOut}
        noAction={stayActive}
        yesLabel="Wyloguj"
        noLabel="Pozostań na stronie"
      />
      <IdleTimer
        ref={idleTimerRef}
        timeout={IDLE_TIMEOUT_MS}
        onIdle={onIdle}
      ></IdleTimer>
    </div>
  );
};

export default IdleTimerContainer;
